export const Divider = () => (
  <hr className="bg-grey-bright border-transparent w-full" />
);
